/** 세션/디바이스 식별자 허용 문자 — 개행·제어문자를 배제해 헤더 주입을 막는다. */
const SESSION_ID_VALID_RE = /^[\w.-]+$/;

/**
 * 세션 ID 형식 검증.
 *
 * URL 쿼리로 들어온 값을 그대로 HTTP 헤더에 실으면, 개행이 섞였을 때 XHR
 * setRequestHeader 가 throw 해 **그 요청 전체가 실패**한다(호출부 try/catch 밖).
 * 발급 시점에 걸러 오염된 값이 저장소에 남지 않게 한다.
 */
export function isValidSessionId(value: unknown): value is string {
  return (
    typeof value === 'string' &&
    value.length > 0 &&
    value.length <= 128 &&
    SESSION_ID_VALID_RE.test(value)
  );
}
